<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.distintaAssegni' | transloco }}</span>

  <button
    mat-icon-button
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
    (click)="chiudi()"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<form class="check-form" #checkForm="ngForm" (ngSubmit)="conferma(checkForm)">
<mat-dialog-content class="content">
  <div class="checks-info-container">
    <div class="checks-info-icon-container" aria-hidden="true">
      <i class="fa-solid fa-circle-info"></i>
    </div>

    <span class="checks-info-text body-medium">{{ 'receipts.ui.unIncassoPuoContenereUnSoloAssegno' | transloco }}</span>
  </div>

  <div class="check-details">
    <span class="label-medium-emphasized">{{ 'receipts.ui.dettaglioAssegno' | transloco }}</span>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="abi-field">
      <mat-label>ABI</mat-label>
      <input matInput inputmode="numeric" maxlength="5" required pattern="[0-9]{5}"
             name="abi" #abiModel="ngModel" [(ngModel)]="check.abi"
             (input)="onBankCoordinateInput($event, 'abi')" />
      @if (abiModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.abiObbligatorio' | transloco }}</mat-error>
      } @else if (abiModel.hasError('pattern')) {
        <mat-error>{{ 'receipts.ui.lAbiDeveContenere5Cifre' | transloco }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cab-field">
      <mat-label>CAB</mat-label>
      <input matInput inputmode="numeric" maxlength="5" required pattern="[0-9]{5}"
             name="cab" #cabModel="ngModel" [(ngModel)]="check.cab"
             (input)="onBankCoordinateInput($event, 'cab')" />
      @if (cabModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.cabObbligatorio' | transloco }}</mat-error>
      } @else if (cabModel.hasError('pattern')) {
        <mat-error>{{ 'receipts.ui.ilCabDeveContenere5Cifre' | transloco }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="generated-bank-field bank-field">
      <mat-label>{{ 'receipts.ui.banca' | transloco }}</mat-label>
      <input matInput disabled [value]="check.banca" />
      @if (isResolvingBank) {
        <i matSuffix class="fa-regular fa-spinner-third fa-spin" [attr.aria-label]="'receipts.ui.ricercaBancaInCorso' | transloco"></i>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="check-number-field">
      <mat-label>{{ 'receipts.ui.numeroAssegno' | transloco }}</mat-label>
      <input matInput inputmode="numeric" maxlength="10" required
             name="numero" #numeroModel="ngModel" [(ngModel)]="check.numero"
             (input)="soloCifre($event, 'numero')" />
      @if (numeroModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.numeroAssegnoObbligatorio' | transloco }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="check-amount-field">
      <mat-label>{{ 'receipts.ui.importo' | transloco }}</mat-label>
      <input matInput type="text" inputmode="decimal" required
             pattern="^(?!0+(?:[,.]0*)?$)[0-9]+(?:[,.][0-9]{0,2})?$"
             name="importo" #importoModel="ngModel" [(ngModel)]="importoDisplay"
             (focus)="preparaImporto($event)"
             (input)="aggiornaImporto($event)"
             (blur)="formatImporto()"
             (keydown)="validaTastoImporto($event)" />
      <span matTextSuffix>&nbsp;€</span>
      @if (importoModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.importoObbligatorio' | transloco }}</mat-error>
      } @else if (importoModel.hasError('pattern')) {
        <mat-error>{{ 'receipts.ui.lImportoDeveEssereMaggioreDiZero' | transloco }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="check-date-field">
      <mat-label>{{ 'receipts.ui.data' | transloco }}</mat-label>
      <input
        matInput
        [matDatepicker]="checkDatePicker"
        required
        name="data"
        #dataModel="ngModel"
        [(ngModel)]="check.data"
        [placeholder]="'receipts.ui.datePlaceholder' | transloco"
      />
      <mat-datepicker-toggle matIconSuffix [for]="checkDatePicker" />
      <mat-datepicker #checkDatePicker />
      @if (dataModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.dataObbligatoria' | transloco }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="check-type-field">
      <mat-label>{{ 'receipts.ui.tipo' | transloco }}</mat-label>
      <mat-select required name="tipo" #tipoModel="ngModel" [(ngModel)]="check.tipo">
        <mat-option value="bancario">{{ 'receipts.ui.bancario' | transloco }}</mat-option>
        <mat-option value="circolare">{{ 'receipts.ui.circolare' | transloco }}</mat-option>
        <mat-option value="circolareVersamentoContanti">
          {{ 'receipts.ui.circolarePerVersamentoContanti' | transloco }}
        </mat-option>
      </mat-select>
      @if (tipoModel.hasError('required')) {
        <mat-error>{{ 'receipts.ui.tipoObbligatorio' | transloco }}</mat-error>
      }
    </mat-form-field>
  </div>

  @if (errore) {
    <div class="check-error body-medium" role="alert">{{ errore }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="check-actions">
  <button
    matButton="filled"
    type="submit"
  >
    {{ 'receipts.ui.conferma' | transloco }}
  </button>
</mat-dialog-actions>
</form>
